import { useEffect } from 'react';

const LOCK_CLASS = 'merch-modal-scroll-lock';
let openCount = 0;

// Keeps body unscrollable while any DsModal is open, even if another script clears ds-modal's inline overflow lock.
export default function useBodyScrollLockGuard(isLocked: boolean) {
  useEffect(() => {
    if (!isLocked) return undefined;

    openCount += 1;
    document.body.classList.add(LOCK_CLASS);

    return () => {
      openCount -= 1;
      if (openCount === 0) document.body.classList.remove(LOCK_CLASS);
    };
  }, [isLocked]);
}
